<script setup lang="ts">
import PerfilOficialPage from '@/components/perfil-oficial/Page.vue';
import useSeo from '@/composables/useSeo';
import { getStandardSeoSuffixes } from '@/utils/seoConstants';

const { standardTitleSuffix } = getStandardSeoSuffixes();

useSeo({
  title: `Perfis Oficiais ${standardTitleSuffix}`,
});
</script>

<template>
  <PerfilOficialPage />
</template>
